var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 2.34375H2.8125C2.55362 2.34375 2.34375 2.55362 2.34375 2.8125V12.1875C2.34375 12.4464 2.55362 12.6562 2.8125 12.6562H12.1875C12.4464 12.6562 12.6562 12.4464 12.6562 12.1875V2.8125C12.6562 2.55362 12.4464 2.34375 12.1875 2.34375Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 5.15625H12.6562",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39062 7.5H7.03125L6.09375 8.67188C6.2479 8.67187 6.39967 8.70989 6.53562 8.78254C6.67157 8.8552 6.78751 8.96025 6.87317 9.08841C6.95883 9.21657 7.01157 9.36387 7.02671 9.51727C7.04186 9.67067 7.01894 9.82544 6.96 9.96788C6.90105 10.1103 6.80789 10.236 6.68877 10.3338C6.56965 10.4317 6.42824 10.4986 6.27707 10.5288C6.12589 10.5589 5.96962 10.5513 5.82209 10.5067C5.67455 10.462 5.54031 10.3816 5.43124 10.2727",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 8.20312L9.375 7.5V10.5469",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.68330f495639a0cc126da812bd5e7236.svg";
export { ForwardRef as ReactComponent };